class CounterElement extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({mode: 'open'});
    
    // Create container for all elements
    this.container = document.createElement('div');
    this.container.style.display = 'flex';
    this.container.style.alignItems = 'center';
    this.container.style.justifyContent = 'center';
    
    // Create currency symbol element
    this.currencyElement = document.createElement('span');
    this.currencyElement.style.marginRight = '2px';
    
    // Create text element for number
    this.textElement = document.createElement('span');
    
    // Create plus symbol element
    this.plusElement = document.createElement('span');
    
    this.container.appendChild(this.currencyElement);
    this.container.appendChild(this.textElement);
    this.container.appendChild(this.plusElement);
    shadow.appendChild(this.container);
    
    this.startValue = 0;
    this.endValue = parseInt(this.getAttribute('end-value')) || 0;
    this.duration = parseInt(this.getAttribute('duration')) || 2000;
    this.formatAsCurrency = this.hasAttribute('currency');
    this.showPlus = this.hasAttribute('plus');
    this.isAnimating = false;
    this.currentValue = 0;
    
    if (this.formatAsCurrency) {
      this.currencyElement.textContent = '$';
    }
    
    if (this.showPlus) {
      this.plusElement.textContent = '+';
    }
    
    this.render();
  }

  connectedCallback() {
    this.setupObserver();
  }

  setupObserver() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (!this.isAnimating) {
          this.currentValue = 0;
          this.startCounting();
        }
      } else {
        this.isAnimating = false;
        this.currentValue = 0;
        this.render();
      }
    }, { threshold: 0.1 });

    observer.observe(this);
  }

  startCounting() {
    this.isAnimating = true;
    const startTime = performance.now();
    
    const updateCount = (currentTime) => {
      if (!this.isAnimating) return;

      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);

      this.currentValue = Math.round(this.endValue * progress);
      this.render();

      if (progress < 1 && this.isAnimating) {
        requestAnimationFrame(updateCount);
      }
    };

    requestAnimationFrame(updateCount);
  }

  render() {
    this.textElement.textContent = this.formatNumber(this.currentValue);
  }

  formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  disconnectedCallback() {
    this.isAnimating = false;
  }
}

customElements.define('counter-element', CounterElement);